module.exports = __webpack_public_path__ + "static/25-b9b7ba6f2970a444a3418a9116607ddb.jpg";